module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/variant-b-osago-932f82562645e8f13c733df869cbd9b6.png.webp";